var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 428.235 428.235",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M307.795 321.176H120.443c-7.397 0-13.382 5.985-13.382 13.382v80.294c0 7.397 5.985 13.382 13.382 13.382h187.353c7.397 0 13.382-5.985 13.382-13.382v-80.294c0-7.396-5.986-13.382-13.383-13.382zM371.19 164.927L223.945 4.339C221.42 1.579 217.773.008 214.121 0c-3.68-.008-7.365 1.571-9.91 4.339L57.045 164.927c-3.581 3.921-4.522 9.579-2.379 14.428a13.367 13.367 0 0012.245 7.998h40.147v93.676c0 7.397 5.985 13.382 13.382 13.382h187.353c7.397 0 13.382-5.985 13.382-13.382v-93.676h40.147a13.368 13.368 0 0012.245-7.998 13.37 13.37 0 00-2.377-14.428z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.5d0763c1.svg";
export { ForwardRef as ReactComponent };